export const IMAGES = {
  MOCKUP_PRODUTO: '/images/mockup_produto_20260508_160743.png',
  ONCO_TREINO_HERO: '/images/onco_treino_hero_20260508_160744.png',
  GARANTIA_BADGE: '/images/garantia_badge_20260508_160744.png',
  ONCO_TREINO_BONUS: '/images/ChatGPT Image 4 de mai. de 2026, 10_55_08.png',
  FOTO_CRIADOR: '/images/retrato_casual_profissional_01_1.png',
} as const;